import * as actions from '../../../store/actions';

const initState = {
  savedData: null,
  error: null,
  loading: false
}

const dAddFormReducer = (state = initState, action) => {
  switch (action.type) {
    case actions.SAVE_FORM_START: {
      return {
        ...initState,
        loading: true
      }
    }
    case actions.SAVE_FORM_SUCCESS: {
      return {
        ...initState,
        loading: false,
        savedData: action.payload
      }
    }
    case actions.SAVE_FORM_ERROR: {
      return {
        ...initState,
        loading: false,
        error: action.payload
      }
    }
    case actions.SAVE_FORM_RESET: {
      return {
        ...initState
      }
    }
    default:
      return state

  }

}

export default dAddFormReducer